export enum ConnectionStatus {
  Full = 'full',
  Basic = 'basic',
  Unconfirmed = 'unconfirmed',
  Deleted = 'deleted',
}

export enum PipelineStatus {
  InTender = 'in_tender',
  PreContract = 'pre_contract',
  InContract = 'in_contract',
  Other = 'other',
}

export enum ConnectionSourceType {
  Invite = 'invite',
  ConnectionRequest = 'connection_request',
  ProfileSharingLink = 'profile_sharing_link',
  AutoManaged = 'auto_managed',
  // A PLG trial is auto-connected to every managed profile on trial start.
  // The backend draws these edges only in the trial's own network, so they are
  // absent from every other org's supply chain. See SUGR-1236.
  AutoTrialManaged = 'auto_trial_managed',
  AutoBecameClient = 'auto_became_client',
  AutoUnclaimed = 'auto_unclaimed',
  SupplierCriticalSupplier = 'supplier_critical_supplier',
}

export type Connection = {
  connectionID: string;
  clientProfileID: string;
  supplierProfileID: string;
  criticalityRating: string;
  confidentialityRating: string;
  holdsPII: string;
  createdAt: string | null;
  modifiedAt: string | null;
  deleted: boolean;
  deletedAt: string | null;
  deletedBy: string | null;
  approvedAt: string | null;
  approvedBy: string | null;
  approvalStatus: string;
  version: number;
  primerEmail: boolean;
  deletedMessage: string;
  sourceType: ConnectionSourceType | null;
  sourceID: string | null;
  status: ConnectionStatus;
};
